<template>
  <div class="page-content-wrapper student-registration-step3">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="card" id="card">
             <div class="card-block">

               <div class="ex-page-content text-center">
                 <span><i class="fa fa-user-circle icon"></i></span>
                 <h3 class="">Completá tus datos</h3>
               </div>

               <div class="alert alert-danger p-3" role="alert" v-if="error">{{ error }}</div>

               <h5 class="card-title" id="cardTitle">Datos personales</h5>
               <div class="card-text">
                 <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg6 col-xl-6" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.lastName.$error }">
                      <label>Apellido</label>
                      <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Perez" v-model="registrationForm.personalData.lastName">
                      <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.lastName.required && $v.registrationForm.personalData.lastName.$error">El apellido es requerido.</div>
                      <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.lastName.minLength && $v.registrationForm.personalData.lastName.$error">El apellido debe tener al menos 3 caracteres.</div>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg6 col-xl-6" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.firstName.$error }">
                      <label>Nombre</label>
                      <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Juan" v-model="registrationForm.personalData.firstName">
                      <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.firstName.required && $v.registrationForm.personalData.firstName.$error">El nombre es requerido.</div>
                      <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.firstName.minLength && $v.registrationForm.personalData.firstName.$error">El nombre debe tener al menos 3 caracteres.</div>
                    </div>
                 </div>

                 <div class="row">
                    <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.dni.$error }">
                       <label>Dni</label>
                       <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="36194445" v-model="registrationForm.personalData.dni">
                      <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.dni.required && $v.registrationForm.personalData.dni.$error">El dni es requerido.</div>
                      <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.dni.minLength && $v.registrationForm.personalData.dni.$error">El dni debe tener al menos 8 numeros.</div>
                    </div>

                     <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.cuil.$error }">
                       <label>Cuil</label>
                       <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="20361944454" v-model="registrationForm.personalData.cuil">
                       <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.cuil.minLength && $v.registrationForm.personalData.cuil.$error">El cuil debe tener al menos 11 numeros.</div>
                       <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.cuil.required && $v.registrationForm.personalData.cuil.$error">El cuil es requerido.</div>
                     </div>

                     <div class="form-group col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.birthDate.$error }">
                       <label>Fecha de nacimiento</label>
                       <masked-input mask="1111-11-11" type="text" class="form-control" v-model="registrationForm.personalData.birthDate" @input="$v.registrationForm.personalData.birthDate.$touch()" />
                       <small>(Ingresar la fecha con el formato: YYYY-MM-DD)</small>
                       <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.birthDate.required && $v.registrationForm.personalData.birthDate.$error">La fecha de nacimiento es requerida.</div>
                     </div>
                 </div>

                 <div class="row">
                    <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.gender.$error }">
                        <label>Sexo</label>
                        <div>
                           <label v-for="gender in genders" class="custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0">
                             <input name="gender" type="radio" class="form-check-input mb-2 mr-sm-2 mb-sm-0" v-bind:value="gender.value" v-model="registrationForm.personalData.gender">
                             {{ gender.text }}
                           </label>
                        </div>
                        <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.gender.required && $v.registrationForm.personalData.gender.$error">El sexo es requerido.</div>
                    </div>

                   <div class="form-group col-sm-12 col-md-2" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.size.$error }">
                     <label>Talla</label>
                     <select v-model="registrationForm.personalData.size" class="form-control mb-2 mr-sm-2 mb-sm-0">
                       <option v-for="size in sizes" :value="size.value">{{ size.text }}</option>
                     </select>
                     <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.size.required && $v.registrationForm.personalData.size.$error">La talla es requerida.</div>
                     <small class="mt-2 d-block"><a class="text-info" href="/static/pdf/talles-ambos.pdf" target="_blank">Ver referencias de talles</a></small>
                   </div>

                   <div class="form-group col-sm-12 col-md-6" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.email.$error }">
                     <label>Correo electrónico</label>
                     <input type="mail" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="ejemplo@example.com" v-model="registrationForm.personalData.email">
                     <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.email.required && $v.registrationForm.personalData.email.$error">El email es requerido.</div>
                     <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.email.email && $v.registrationForm.personalData.email.$error">Ingrese un email válido.</div>
                   </div>
                 </div>
               </div>

               <!--lugar de nacimiento-->
               <h5 class="card-title">Lugar de nacimiento</h5>
               <div class="card-text">
                  <div class="row">
                    <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.birthPlace.nationality.$error }">
                       <label>Nacionalidad</label>
                       <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Argentina" v-model="registrationForm.personalData.birthPlace.nationality">
                       <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.birthPlace.nationality.required && $v.registrationForm.personalData.birthPlace.nationality.$error">La nacionalidad es requerida.</div>
                    </div>
                    <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.birthPlace.province.$error }">
                       <label>Provincia</label>
                      <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Corrientes" v-model="registrationForm.personalData.birthPlace.province">
                      <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.birthPlace.province.required && $v.registrationForm.personalData.birthPlace.province.$error">La provincia de nacimiento es requerida.</div>
                    </div>
                    <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.birthPlace.locality.$error }">
                      <label>Localidad</label>
                      <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Corrientes" v-model="registrationForm.personalData.birthPlace.locality">
                      <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.birthPlace.locality.required && $v.registrationForm.personalData.birthPlace.locality.$error">La localidad de nacimiento es requerida.</div>
                    </div>
                  </div>
               </div>

               <!--lugar de residencia actual-->
               <h5 class="card-title">Lugar de residencia actual</h5>
               <div class="card-text">
                   <div class="row">
                     <div class="form-group col-sm-12 col-md-6" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.street.$error }">
                        <label>Domicilio / Calle</label>
                        <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Rioja" v-model="registrationForm.personalData.currentResidence.street">
                        <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.street.required && $v.registrationForm.personalData.currentResidence.street.$error">La calle es requerida.</div>
                     </div>
                     <div class="form-group col-sm-12 col-md-2" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.streetNumber.$error }">
                        <label>N°</label>
                        <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="663" v-model="registrationForm.personalData.currentResidence.streetNumber">
                        <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.streetNumber.required && $v.registrationForm.personalData.currentResidence.streetNumber.$error">El número de la calle es requerido.</div>
                     </div>
                     <div class="form-group col-sm-12 col-md-2">
                       <label>Piso</label>
                       <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0"  placeholder="1" v-model="registrationForm.personalData.currentResidence.floor">
                     </div>
                     <div class="form-group col-sm-12 col-md-2">
                       <label>Depto</label>
                       <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0"  placeholder="1A" v-model="registrationForm.personalData.currentResidence.departamentNumber">
                     </div>
                   </div>


                  <div class="row">
                    <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.country.$error }">
                      <label>País</label>
                      <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Argentina" v-model="registrationForm.personalData.currentResidence.country">
                      <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.country.required && $v.registrationForm.personalData.currentResidence.country.$error">El país es requerido.</div>
                    </div>
                    <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.province.$error }">
                      <label>Provincia</label>
                      <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Corrientes" v-model="registrationForm.personalData.currentResidence.province">
                      <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.province.required && $v.registrationForm.personalData.currentResidence.province.$error">La provincia actual es requerida.</div>
                    </div>
                     <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.locality.$error }">
                       <label>Localidad</label>
                       <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Corrientes" v-model="registrationForm.personalData.currentResidence.locality">
                       <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.locality.required && $v.registrationForm.personalData.currentResidence.locality.$error">La localidad actual es requerida.</div>
                     </div>
                  </div>

                 <div class="row">
                   <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.neighborhood.$error }">
                     <label>Barrio</label>
                     <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Libertad" v-model="registrationForm.personalData.currentResidence.neighborhood">
                     <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.neighborhood.required && $v.registrationForm.personalData.currentResidence.neighborhood.$error">El barrio es requerido.</div>
                   </div>

                   <div class="form-group col-sm-12 col-md-3" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.zipCode.$error }">
                     <label>Código Postal</label>
                     <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0"  placeholder="3400" v-model="registrationForm.personalData.currentResidence.zipCode">
                     <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.zipCode.required && $v.registrationForm.personalData.currentResidence.zipCode.$error">El código postal es requerido.</div>
                   </div>
                 </div>

                  <div class="row">
                     <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.phone.$error }">
                        <label>Teléfono fijo</label>
                        <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="3794123456" v-model="registrationForm.personalData.currentResidence.phone">
                       <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.phone.required &&  $v.registrationForm.personalData.currentResidence.phone.$error">El teléfono es requerido.</div>
                     </div>

                     <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.cellPhone.$error }">
                        <label>Celular</label>
                        <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="3794123456" v-model="registrationForm.personalData.currentResidence.cellPhone">
                       <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.cellPhone.required && $v.registrationForm.personalData.currentResidence.cellPhone.$error">El celular es requerido.</div>
                     </div>

                     <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.cellPhoneCompany.$error }">
                        <label>Compañia</label>
                        <select v-model="registrationForm.personalData.currentResidence.cellPhoneCompany" class="form-control mb-2 mr-sm-2 mb-sm-0">
                           <option v-for="Company in cellPhoneCompanies" :value="Company.value">{{ Company.text }}</option>
                        </select>
                       <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.cellPhoneCompany.required && $v.registrationForm.personalData.currentResidence.cellPhoneCompany.$error">La compañia celular es requerida.</div>
                     </div>
                  </div>

                 </div>

                  <div class="text-center mt-4 form-buttons">
                     <a href="javascript:void(0);" @click="submit()" class="btn btn-primary go-print">Continuar</a>
                  </div>
             </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import sizes from '../../data/sizes'
import genders from '../../data/genders'
import cellPhoneCompanies from '../../data/cellPhoneCompanies'
import MaskedInput from 'vue-masked-input'

export default {
  name: 'student-registration-step-3',


  components: {
    MaskedInput
  },


  created(){
    // Obtenemos todas las configuraciones desde el api
    this.getAllConfigurations()

    this.verifyStep3Completed()

    this.getRegistrationForm()
  },


  data () {
    return {
      sizes: sizes,
      cellPhoneCompanies: cellPhoneCompanies,
      genders: genders,
      user: this.$store.state.auth.user,
      error: null
    }
  },


  computed: {

  	registrationForm:function(){
  		return this.$store.getters.getRegistrationForm
  	},

    registrationToCareer: function () {
      return this.$store.getters.getRegistrationToCareer
    },

    // traemos la configuracion para saber el año lectivo actual
    configItemAcademicYear: function () {
      return this.$store.getters.getConfigByKey('registrationToCareers.academicYear')
    }

  },


  validations: {
    registrationForm:{
      personalData: {
        lastName: { required, minLength: minLength(3) },
        firstName:{required, minLength: minLength(3) },
        dni: { required, minLength: minLength(8) },
        gender: { required },
        cuil: { required, minLength: minLength(11) },
        size: { required },
        birthDate:{ required },
        birthPlace:{
          locality: { required },
          province: { required },
          nationality: { required }
        },
        email:{ required, email },
        currentResidence:{
          street: { required },
          streetNumber: { required },
          neighborhood: { required },
          locality: { required },
          province: { required },
          country: { required },
          zipCode: { required},
          phone: { required, minLength: minLength(6) },
          cellPhone: { required, minLength: minLength(8) },
          cellPhoneCompany:{ required }
        }
      }
    }
  },


  methods:{

    submit: function () {
      var self = this;

      $('.go-next-step').attr('disabled', true)

      this.$v.registrationForm.personalData.$touch();

	    if(!this.$v.registrationForm.personalData.$error){

        if (this.registrationToCareer) {
          this.registrationForm.currentCareer = this.registrationToCareer.career
        }
        if (this.registrationToCareer) {
          this.registrationForm.currentLevel = this.registrationToCareer.level
        }
        this.registrationForm.user = this.user._id;

        this.$store.dispatch('editRegistrationForm', { form: this.registrationForm })
          .then((response) => {

            if(self.configItemAcademicYear && self.configItemAcademicYear.value) {

              const academicYear = self.configItemAcademicYear.value

              var studentFileId = (response.data._id ? response.data._id : null);

              // Registramos el progreso y luego redirigimos a la impresion de la ficha

              this.$store.dispatch('editRegistrationToCareer', { registrationToCareer: { academicYear: academicYear, user: self.user._id, studentRegistrationStatus: 'pending-step-3', studentFile: studentFileId } })
                .then((response) => {

                  if(response.success) {

                    this.$router.push('/print-student-registration/');

                  } else {

                    self.error = response.message

                  }

                  $('.go-next-step').attr('disabled', false)
                })
                .catch((response) => {
                  $('.go-next-step').attr('disabled', false)
                })
            }

          })
          .catch((error) => {
            this.error = 'Ha ocurrido un error. Intentelo nuevamente mas tarde.'
          })

	    }
    },


    getRegistrationForm: function () {
      this.$store.dispatch('getRegistrationForm', { user : this.user._id })
        .then((response) => {

          if (!this.registrationForm) {
            this.$store.dispatch('cleanRegistrationForm');
          }

          if(response.data && response.data.personalData && response.data.personalData.birthDate) {
            this.registrationForm.personalData.birthDate = response.data.personalData.birthDate.split('T')[0];
          }
        })
        .catch(error => {
          //this.error = 'Ha ocurrido un error. Intentelo nuevamente mas tarde.'
        })
    },


    verifyStep3Completed: function () {

      var self = this

      if(self.configItemAcademicYear && self.configItemAcademicYear.value) {

        const academicYear = self.configItemAcademicYear.value

        this.$store.dispatch('getRegistrationToCareer', { registrationToCareer: { academicYear: academicYear, user: self.user._id } })
          .then((response) => {

            if(response.data && response.data.studentRegistrationStatus) {
              if (response.data.studentRegistrationStatus != 'pending' &&
                response.data.studentRegistrationStatus != 'pending-step-1' &&
                response.data.studentRegistrationStatus != 'pending-step-2' &&
                response.data.studentRegistrationStatus != '') {
                return true;
              }
              return false;
            }
          })
          .catch((error) => {
            this.error = 'Ha ocurrido un error. Intentelo nuevamente mas tarde.'
          })

        return false
      }
    },


    getAllConfigurations: function () {

      var self = this

      this.$store.dispatch('getAllConfigurations')
        .then((response) => {

        })
        .catch((error) => {
          this.error = 'Ha ocurrido un error. Intentelo nuevamente mas tarde.'
        })

    }

  }

}
</script>
<style>
  .icon {
    font-size: 47px;
    margin-bottom: 10px;
  }
  .card-title {
    margin-top: 15px;
  }
  .ex-page-content {
    margin-top: 40px;
  }
  .go-print {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/student_registration/StudentRegistrationStep3.vue